// extracted by mini-css-extract-plugin
export var content = "Layout-module--content--a84e7";
export var main = "Layout-module--main--feab6";